module.exports = __webpack_public_path__ + "static/rubik-6b0b2176a3eb560cc6de0b99d76286a4.woff2";